function addToWishlist(event, customerId, productId, emptySrc, fullSrc, current, array) {
  event.preventDefault();
  const pId = `gid://shopify/Product/${productId}`;
  const cId = `${customerId}`;

  fetch('https://hook.eu2.make.com/2q0hrofsdqzccr0bp9jgznjsol0mtysa', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      productId: pId,
      customerId: cId,
      productArray: array,
      method: 'add',
    }),
  })
    .then((response) => response.text())
    .then((data) => {
      if (data == 'Accepted') {
        current.querySelector('img').src = fullSrc;

        setTimeout(() => {
          if (window.location.href.includes('/products/')) {
            // Refresh the main product container
            const mainProduct = document.querySelector('.main-product-container');
            if (mainProduct) {
              fetch(window.location.href)
                .then((res) => res.text())
                .then((html) => {
                  const parser = new DOMParser();
                  const doc = parser.parseFromString(html, 'text/html');
                  const newMain = doc.querySelector('.main-product-container');
                  if (newMain) mainProduct.replaceWith(newMain);
                })
                .catch((err) => console.error('Error refreshing main product:', err));
            }
          } else {
            // Refresh all product cards
            fetch(window.location.href)
              .then((res) => res.text())
              .then((html) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newCards = doc.querySelectorAll('.product-card');
                newCards.forEach((newCard) => {
                  const id = newCard.dataset.productId;
                  const oldCard = document.querySelector(`.product-card[data-product-id='${id}']`);
                  if (oldCard) oldCard.replaceWith(newCard);
                });
              })
              .catch((err) => console.error('Error refreshing product cards:', err));
          }
        }, 2500); // 2 seconds delay for metafield update

        return data;
      } else {
        return data;
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

function removeFromWishlist(event, customerId, productId, emptySrc, fullSrc, current, array) {
  event.preventDefault();
  const pId = `gid://shopify/Product/${productId}`;
  const cId = `${customerId}`;

  fetch('https://hook.eu2.make.com/2q0hrofsdqzccr0bp9jgznjsol0mtysa', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      productId: pId,
      customerId: cId,
      productArray: array,
      method: 'delete',
    }),
  })
    .then((response) => response.text())
    .then((data) => {
      if (data == 'Accepted') {
        current.querySelector('img').src = emptySrc;

        setTimeout(() => {
          if (window.location.href.includes('/products/')) {
            // Refresh the main product container
            const mainProduct = document.querySelector('.main-product-container');
            if (mainProduct) {
              fetch(window.location.href)
                .then((res) => res.text())
                .then((html) => {
                  const parser = new DOMParser();
                  const doc = parser.parseFromString(html, 'text/html');
                  const newMain = doc.querySelector('.main-product-container');
                  if (newMain) mainProduct.replaceWith(newMain);
                })
                .catch((err) => console.error('Error refreshing main product:', err));
            }
          } else {
            // Refresh all product cards
            fetch(window.location.href)
              .then((res) => res.text())
              .then((html) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newCards = doc.querySelectorAll('.product-card');
                newCards.forEach((newCard) => {
                  const id = newCard.dataset.productId;
                  const oldCard = document.querySelector(`.product-card[data-product-id='${id}']`);
                  if (oldCard) oldCard.replaceWith(newCard);
                });
              })
              .catch((err) => console.error('Error refreshing product cards:', err));
          }
        }, 2500); // 2 seconds delay for metafield update
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}
